var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeaturedProject = function SvgFeaturedProject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 10.6c0 8.4-9.6 14.4-9.6 14.4S1 19 1 10.6a9.6 9.6 0 0 1 19.2 0Z",
    fill: "#62294B",
    stroke: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.028 6.028c.258-.258.607-.403.972-.403h4c.1 0 .195.04.265.11l3 3c.068.068.11.162.11.265v6A1.375 1.375 0 0 1 14 16.375H8A1.375 1.375 0 0 1 6.625 15V7c0-.365.145-.714.403-.972ZM8 6.375h3.625V9c0 .207.168.375.375.375h2.625V15a.624.624 0 0 1-.625.625H8A.625.625 0 0 1 7.375 15V7A.625.625 0 0 1 8 6.375Zm4.375.53 1.72 1.72h-1.72v-1.72ZM9 11.125a.375.375 0 0 0 0 .75h4a.375.375 0 0 0 0-.75H9ZM8.625 13.5c0-.207.168-.375.375-.375h4a.375.375 0 0 1 0 .75H9a.375.375 0 0 1-.375-.375ZM9 9.125a.375.375 0 1 0 0 .75h1a.375.375 0 0 0 0-.75H9Z",
    fill: "#fff"
  })));
};
export default SvgFeaturedProject;